module.exports = __webpack_public_path__ + "static/media/Xplanations.426fc583.png";